<script lang="ts" setup>
import BaseButton from '@/components/base/BaseButton.vue';
import { useAppStore } from '@/stores/app';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();

const formChoose = defineModel('formChoose');
const appStore = useAppStore();

const isJuniorLoginPage = computed(() => route.name === 'loginJunior');

const props = defineProps({
  buttonVariant: {
    type: String,
    default: 'primary'
  },
  kvImgError: { type: Boolean, default: false }
});

const showBaseButton = computed(() => {
  if (isJuniorLoginPage.value) {
    return formChoose.value === '';
  } else {
    return (
      !(formChoose.value === 'SignupForm' || formChoose.value === 'SMSVerification') &&
      !appStore.isLanding
    );
  }
});
</script>

<template>
  <div class="login-background" :class="{ 'error-img': kvImgError }">
    <slot />
    <!-- SignupForm -->
    <BaseButton
      v-if="showBaseButton"
      :variant="buttonVariant"
      :class="{ 'junior-join-btn': isJuniorLoginPage }"
      class="join-btn--mobile"
      @click="formChoose = 'SignupForm'"
      size="lg"
      :rounded="true"
    >
      免費加入
    </BaseButton>
  </div>
</template>

<style lang="scss" scoped>
$loginBackgroundMaxHeight: 911px;
$loginBackgroundMinHeight: 850px;
$loginBackgroundColor: #191919;

.login-background {
  width: 100%;
  height: 100%;
  // max-height: $loginBackgroundMaxHeight;
  // min-height: $loginBackgroundMinHeight;
  overflow: hidden;
  background-color: $loginBackgroundColor;

  // @include media-breakpoint-down(md) {
  //   max-height: inherit;
  //   min-height: inherit;
  // }

  .swiper-pagination {
    bottom: 180px;
  }
}

.error-img {
  min-height: $loginBackgroundMinHeight;
}

.join-btn--mobile {
  @include absolute;
  z-index: 2;
  left: 50%;
  bottom: 50%;
  transform: translate(-50%, -50%);
  font-size: 32px;
  font-weight: 600;
  line-height: 38.4px;
  width: 250px;
  filter: drop-shadow(10px 10px 30px #00000099);
}

.junior-join-btn {
  top: 45%;
  left: 20%;
  bottom: auto;
  transform: none;
}

@include media-breakpoint-down(lg) {
  .join-btn--mobile {
    left: 50%;
    top: 60%;
    transform: translateX(-50%);
    font-size: 18px;
    font-weight: 700;
    height: 48px;
  }
}
</style>
